<template>
<div class="chapter">
<div class="inner_page">
<div class="small">
<p><br/><br/>In the early 1920s, Stalin and a few colleagues were relaxing in Morozovka Park, lying in the grass. One asked: “What’s the best thing in the world?” “Books,” replied one. “There is no greater pleasure than a woman, your woman,” said another. Then Stalin said, “The sweetest thing is to devise a plan, then, being on the alert, waiting in ambush for a goo-oo-ood long time, finding out where the person is hiding. Then catch the person and take revenge!”<br/><br/></p>
<p class="indent">—M<span class="small">IKLOS</span> K<span class="small">UN</span>, <i>Stalin: An Unknown Portrait</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// other.vue?5e85f259